/**
 * @generated SignedSource<<1cae7577c8002458f48df7684121408f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStakingType = "FLEXIBLE" | "LOCKED";
export type AssetStakeDetailsViewQuery$variables = {
  id?: string | null | undefined;
};
export type AssetStakeDetailsViewQuery$data = {
  readonly assetById: {
    readonly __typename: string;
    readonly id: string;
    readonly isActive: boolean | null | undefined;
    readonly logoUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly price: PrecisionFloat | null | undefined;
    readonly staking?: {
      readonly currentRewardPeriodEndsAt: TimeScalar | null | undefined;
      readonly enabled: boolean | null | undefined;
      readonly enabledForAutoStaking: boolean | null | undefined;
      readonly minimumStakeableAmount: PrecisionFloat | null | undefined;
      readonly nextRewardAt: TimeScalar | null | undefined;
      readonly rewardIntervalInDays: number | null | undefined;
      readonly type: AssetStakingType | null | undefined;
      readonly unboundedPeriodInDays: number | null | undefined;
      readonly yearlyInterest: number | null | undefined;
    } | null | undefined;
    readonly symbol: string | null | undefined;
  } | null | undefined;
};
export type AssetStakeDetailsViewQuery = {
  response: AssetStakeDetailsViewQuery$data;
  variables: AssetStakeDetailsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "assetById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetStaking",
            "kind": "LinkedField",
            "name": "staking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rewardIntervalInDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "yearlyInterest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumStakeableAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextRewardAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentRewardPeriodEndsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unboundedPeriodInDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledForAutoStaking",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "CryptoAsset",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetStakeDetailsViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssetStakeDetailsViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "124d47b8d409a47018b71fba820626f1",
    "id": null,
    "metadata": {},
    "name": "AssetStakeDetailsViewQuery",
    "operationKind": "query",
    "text": "query AssetStakeDetailsViewQuery(\n  $id: ID\n) {\n  assetById(id: $id) {\n    __typename\n    id\n    name\n    symbol\n    isActive\n    logoUrl\n    price\n    ... on CryptoAsset {\n      staking {\n        enabled\n        rewardIntervalInDays\n        yearlyInterest\n        minimumStakeableAmount\n        nextRewardAt\n        currentRewardPeriodEndsAt\n        type\n        unboundedPeriodInDays\n        enabledForAutoStaking\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27ab713a15585a86e08e5a0218ffc8eb";

export default node;
